<template >

    <span >
      <el-select v-model="channelId" :multiple="multiple" :placeholder="placeholder"
          clearable
          filterable
          remote
          reserve-keyword
          :remote-method="remoteMethod"
          :disabled="disabled"
          @change="$emit('change',channelId)">
        <el-option
         v-for="item in channels"
         :key="item.id"
         :label="item.channelName"
         :value="item.id">
       </el-option>

      </el-select>

      <el-button style="margin-left:30px;" v-if="multiple" @click="selectAll" type="text">{{isSelectAll?'取消全选':'全选'}}</el-button>
    </span>

</template>

<script>
import ChannelModel from '@/framework/models/channelModel'
export default {
  name: 'channel-select',
  data: function () {
    return {
      channels: [],
      channelId: [],
      isSelectAll: false
    }
  },
  props: {
    multiple: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    placeholder: {
      type: String,
      default: function () {
        return '请选择'
      }
    },
    disabled: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  methods: {
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.findChannels(query)
        }, 200)
      } else {
        this.options = []
      }
    },
    settingDefaultChannelInfo (channelInfo) {
      this.channels = [channelInfo]
      this.setChannelIds(channelInfo.id)
    },
    selectAll: function () {
      if (this.isSelectAll) {
        this.channelId = []
        this.isSelectAll = false
        this.$emit('change', [])
        return
      }

      let _this = this
      let temp = []
      for (var item of _this.channels) {
        temp.push(item.id)
      }

      this.channelId = temp

      this.isSelectAll = true

      this.$emit('change', temp)
    },
    clear: function () {
      this.channelId = []
    },
    setChannelIds: function (channelId) {
      this.channelId = channelId
    },
    findChannels: function (query) {
      let params = {
        keyword: query
      }
      let _this = this
      let listener = {
        success: function (dataInfo) {
          _this.channels = dataInfo.datas
        }
      }
      ChannelModel.findChannelsByKeyWord(_this, params, listener)
    }
  }
}
</script>

<style lang="css" scoped>
</style>
